<script setup lang="ts">
import BaseButton from '@/components/base/BaseButton.vue'
import TheBottomSheet from '@/components/TheBottomSheet.vue'
import { useMultiplayerMine } from '@/composables/game/multiplayer-mine'
import mineMagnetIcon from '@/assets/images/multiplayer/mine-magnet-icon.webp'
import mineIcon from '@/assets/images/multiplayer/mine-icon.png'

defineProps<{ show: boolean; acquiredCount: number }>()
const emit = defineEmits<{ hide: [] }>()

const { openPlantMineModal } = useMultiplayerMine()

function onUseNow() {
  emit('hide')
  openPlantMineModal()
}
</script>

<template>
  <TheBottomSheet
    :show="show"
    centered
    @hide="emit('hide')"
  >
    <div class="flex flex-col items-center gap-6 w-full">
      <div class="flex flex-col items-center max-w-[270px]">
        <img :src="mineMagnetIcon" class="w-[66px] h-[66px] object-contain" alt="Magnet">
        <h2 class="font-pilat font-bold text-[24px] leading-8 text-white text-center uppercase">
          MINES COLLECTED!
        </h2>
        <p class="text-white/60 text-base font-semibold text-center">
          You grabbed the mines before they could hurt you.
        </p>
      </div>

      <div class="w-full bg-[rgba(44,44,46,0.66)] backdrop-blur-[12px] border-2 border-[#3a3a3c] rounded-[24px] p-2 flex items-center gap-2">
        <img :src="mineIcon" class="w-6 h-6" alt="Mine">
        <span class="text-white text-sm font-semibold">
          <b>{{ acquiredCount }}</b> mine{{ acquiredCount !== 1 ? 's' : '' }} added to your inventory
        </span>
      </div>

      <BaseButton class="w-full" @click="onUseNow">
        USE RIGHT NOW!
      </BaseButton>
    </div>
  </TheBottomSheet>
</template>
